import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"

const HeaderSectionRight = () => {
  return (
    <CMSRender
      contentType="Image"
      match={{ "content.id": "FeaturesHeaderImage" }}
      renderItem={(data, id) => {
        return <div 
          key={id}
          className="flex w-full lg:w-1/2 h-[320px] md:h-[420px] lg:h-[470px] xl:h-[500px] items-start md:items-center lg:items-start justify-center lg:justify-start aspect-710/580 z-10 mt-4 lg:mt-0 mx-auto"
        >
          <img
            src={data.image[0]}
            alt="Oxford Dictionary Logo"
            className="h-full aspect-710/580 object-contain"
            />
        </div>
      }}
    />
  );
};

export default HeaderSectionRight;
